const SIZE_EMOTION_PANEL = 50;

const EMOTION_PANEL_COLOR= "#000000";

const EMOTION_PANEL_BG_COLOR = "#FFFFFF";

export { SIZE_EMOTION_PANEL, EMOTION_PANEL_COLOR, EMOTION_PANEL_BG_COLOR };
